import { render, staticRenderFns } from "./TreeEditMessageModal.vue?vue&type=template&id=449bb2e4&scoped=true&"
import script from "./TreeEditMessageModal.vue?vue&type=script&lang=ts&"
export * from "./TreeEditMessageModal.vue?vue&type=script&lang=ts&"
import style0 from "./TreeEditMessageModal.vue?vue&type=style&index=0&id=449bb2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bb2e4",
  null
  
)

export default component.exports